import * as actionTypes from "./actionTypes";


export const initMultiRouterStart = (filter) => {
  return {
    type: actionTypes.INIT_MULTI_ROUTER_START,
    filter
  }
}

export const getMultiRouter = (single) => {
  return {
    type: actionTypes.GET_MULTI_ROUTER,
    single: single
  }
}

export const setMultiRouter = (info) => {
  return {
    type: actionTypes.SET_MULTI_ROUTER,
    multiRouter: info
  };
}

export const getMultiRouterSuccess = () => {
  return {
    type: actionTypes.GET_MULTI_ROUTER_SUCCESS
  };
}

export const getMultiRouterFailed = () => {
  return {
    type: actionTypes.GET_MULTI_ROUTER_FAILED
  };
}

export const initAssignPodsRequest = () => ({ type: actionTypes.ASSIGN_POD_REQUEST})

export const assignPods = (serialNumber, rMac, ssid) => {
  // console.log('RMAC', rMac)
  return {
    type: actionTypes.ASSIGN_POD,
    serialNumber,
    rMac,
    ssid
  };
};

export const assignPodsSuccess = (message) => ({
  type: actionTypes.ASSIGN_POD_SUCCESS,
  message,
});

export const assignPodsFailed = (message) => ({
  type: actionTypes.ASSIGN_POD_FAILED,
  message
});


export const initunClaimedPodsRequest = () => ({ type: actionTypes.UNCLAIMED_POD_REQUEST})

export const unClaimedPods = (serialNumber,ssid) => {
  return {
    type: actionTypes.UNCLAIMED_POD,
    serialNumber,
    ssid
  };
};

export const unClaimedPodsSuccess = (message) => ({
  type: actionTypes.UNCLAIMED_POD_SUCCESS,
  message,
});

export const unClaimedPodsFailed = (message) => ({
  type: actionTypes.UNCLAIMED_POD_FAILED,
  message
});

export const resetMultiRouterStatus = () => ({type: actionTypes.RESET_MULTI_ROUTER_STATUS})


